export default {
    pendingCalls: 0
}